// App UI i18n (vue-i18n, legacy/Options-API mode).
//
// Scope: the dashboard product experience only. SEO surfaces — document
// titles, meta descriptions, the blog and /page/* landing views — stay
// English on purpose: they are prerendered for English search queries and
// translating them would churn their SEO.
//
// Locale resolution: explicit user choice (localStorage) wins, then the
// browser language, then English. Prerender (headless Chromium, en-US)
// therefore always snapshots English, which is what crawlers should see.
import { createI18n } from 'vue-i18n';
import en from './en';
import tr from './tr';

const STORAGE_KEY = 'spt_lang';
export const SUPPORTED_LOCALES = ['en', 'tr'];

function detectLocale () {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);

        if (SUPPORTED_LOCALES.includes(stored)) {
            return stored;
        }
    } catch (_) {
        // Storage unavailable (private mode) — fall through to the browser.
    }

    try {
        const nav = (navigator.language || '').toLowerCase();

        if (nav.startsWith('tr')) {
            return 'tr';
        }
    } catch (_) {
        // ignore
    }

    return 'en';
}

const i18n = createI18n({
    legacy: true,
    locale: detectLocale(),
    fallbackLocale: 'en',
    messages: { en, tr },
    // Missing-key warnings drown the dev console because SEO views are
    // intentionally unkeyed; fallback text is the behavior we want.
    silentFallbackWarn: true,
});

export function setLocale (locale) {
    if (!SUPPORTED_LOCALES.includes(locale)) {
        return;
    }

    i18n.global.locale = locale;

    try {
        localStorage.setItem(STORAGE_KEY, locale);
    } catch (_) {
        // Private mode: the choice just doesn't persist.
    }

    try {
        document.documentElement.setAttribute('lang', locale);
    } catch (_) {
        // ignore
    }
}

export default i18n;
